export default __webpack_public_path__ + "static/media/28.8d99f031.png";